<template>
    <div class="complete-supervision-modal">
        <b-modal ref="modal" size="lg" title="Complete supervision session" ok-title="Sign Off" @ok="complete" :ok-disabled="isDisabled">
          <b-col md="12">
            <p>
              To confirm this supervision session has been completed succesfully please leave a signature below.
            </p>
            <br/>
            <p class="label-title">Signature</p>
            <SignaturePad :modelValue="signature" @update:modelValue="signature = $event" :width="734" :height="178"></SignaturePad>
          </b-col>
          <b-col md="12">
            <b-form-checkbox
                id="useGlobalSignature"
                v-model="useGlobalSignature"
                name="useGlobalSignature"
                value="1"
                unchecked-value="0"
                v-if="!this.form.guest">
              Use global signature
            </b-form-checkbox>
          </b-col>
        </b-modal>
    </div>
</template>

<script>

    import SignaturePad from "@/components/form/SignaturePad.vue";
    import CheckboxFormItem from "@/components/form/CheckboxFormItem.vue";

    export default {
      name: "CompleteSupervisionModal",
      props: ['entryId','form','guest'],
      components: {CheckboxFormItem, SignaturePad},
        data() {
            return {
              loading: false,
              signature:'',
              useGlobalSignature:"0"
            }
        },
        computed: {
          isDisabled()
          {
            return this.signature === '' && this.useGlobalSignature === "0";
          },
        },
        mounted: function ()
        {

        },

        methods:
          {
            show()
            {
              if(this.entryId)
              {
                this.$refs.modal.show();
              }
            },
            close()
            {
                this.$refs.modal.hide();
            },
            complete(event)
            {
              event.preventDefault();

              this.loading = true;

              let data = this.$formTools.flatten(this.form);
              let mapped_data = this.$formTools.mapToJson(data);

              this.$api.v2.post(`supervision/complete`,
        {
                entryId:String(this.entryId),
                signature:this.signature,
                useGlobalSignature:this.useGlobalSignature,
                guest:this.guest,
                form:mapped_data
              },
      {
                headers:
                    {
                      'Content-Type': 'application/json'
                    }
              }
              ).then((resp) =>
              {
                this.$success('Completed Successfully', resp.body.message);
                this.$router.push('/dashboard');
              }).catch((resp) =>
              {
                this.$httpError('Failed to complete', resp);
              });
            }
        }
    }
</script>